<template>
  <app-bar title="Booking Summary" :member-id="bookingInfo.memberId" />
  <v-overlay :model-value="isLoading" class="align-center justify-center">
    <v-progress-circular color="white" size="64" indeterminate />
  </v-overlay>

  <transition name="fade">
    <div class="booking-card elevation-2">
      <v-container class="px-0">
        <div class="d-flex justify-space-between align-center">
          <v-sheet class="text-end">
            <v-img
              :src="ui.squareLogoLink"
              width="128"
              rounded="xl"
              class="mt-n5"
            />
          </v-sheet>
          <v-sheet class="text-end">
            <p>{{ bookingInfo.shop }}</p>
            <booking-status-display :status="bookingInfo.status" />
          </v-sheet>
        </div>
      </v-container>
      <v-divider class="border-opacity-50 booking-divider" />
      <v-container class="py-6">
        <v-row>
          <v-col class="text-left pa-0"> Attendee </v-col>
          <v-col class="text-right pa-0">
            {{ bookingInfo.attendee }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left pa-0"> Branch </v-col>
          <v-col class="text-right pa-0">
            {{ bookingInfo.branch }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left pa-0"> Class </v-col>
          <v-col class="text-right pa-0">
            {{ bookingInfo.topic }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left pa-0"> Date </v-col>
          <v-col class="text-right pa-0">
            {{ bookingInfo.date }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left pa-0"> Time </v-col>
          <v-col class="text-right pa-0">
            {{ bookingInfo.time }}
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="border-opacity-50 booking-divider" />
      <v-container v-if="bookingInfo.status === 'completed'">
        <v-row>
          <v-col auto class="pa-0" />
          <div class="flex-shink-1">
            <qr-code
              :text="'BECG:' + bookingInfo.bookingId"
              class="d-flex pa-5 qr-code-div"
              :size="220"
            />
            <p class="pb-5 qr-text">
              {{ bookingInfo.bookingId }}
            </p>
          </div>
          <v-col auto class="pa-0" />
        </v-row>
      </v-container>
    </div>
  </transition>
  <div class="text-start mx-5 mb-10" v-if="classroomNote">
    <h5>Note</h5>
    <p>{{ classroomNote }}</p>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { useRoute } from "vue-router";
import AppBar from "@/components/AppBar.vue";
import BookingStatusDisplay from "@/components/BookingStatusDisplay.vue";
import BackendConnector from "@/util/BackendConnector";
import moment from "moment";
import axios from "axios";
import { useUi } from "@/util/ShopUi";

const route = useRoute();
const ui = ref({});
useUi(route.params.shopId).then((responseUi) => {
  ui.value = responseUi;
});

const classroomNote = ref(null);
const isLoading = ref(true);

const bookingInfo = reactive({
  bookingId: route.params.bookingId,
  memberId: "",
  shopId: "",
  shop: "Booking Engine",
  attendee: "Chet Chetchaiyan",
  branch: "Bangkok",
  topic: "Python 101",
  date: "Jan 01, 2024",
  time: "18:00",
  status: "completed",
});

loadBooking(route.params.bookingId).then((response) => {
  isLoading.value = false;
  bookingInfo.eventId = response.data.event_id;
  bookingInfo.shopId = response.data.shop_id;
  bookingInfo.shop = response.data.shop;
  bookingInfo.memberId = response.data.member_id;
  bookingInfo.attendee = response.data.attendee;
  bookingInfo.branch = response.data.branch;
  bookingInfo.topic = response.data.topic;
  bookingInfo.date = moment(response.data.datetime).format("MMM D, YYYY");
  bookingInfo.time = moment(response.data.datetime).format("HH:mm");
  bookingInfo.status = response.data.status;
  console.log("Booking Info: ", bookingInfo);

  BackendConnector.loadClassroom(bookingInfo.eventId).then((response) => {
    classroomNote.value = response.data.summary_note;
  });
});

async function loadBooking(bookingId) {
  return axios
    .get(
      `${process.env.VUE_APP_BACKEND_URL}/api/classroom_booking/id-${bookingId}`
    )
    .then((response) => {
      return response;
    });
}
</script>

<style scoped>
.booking-card {
  margin: 2rem 1rem;
  padding: 2rem;
  background: white;
}

.booking-divider {
  border-style: dashed;
}

.qr-text {
  font-weight: 600;
  font-size: 1.5rem;
}
</style>
